import React from 'react'

const Download = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.9086 8.525C14.8208 8.175 14.4695 8 14.1182 8H12.3618V4.9375C12.3618 2.75 10.6054 1 8.40988 1H4.89705C4.19448 1 3.57974 1.6125 3.57974 2.3125V8H1.82332C1.47204 8 1.12075 8.175 1.03293 8.525C0.945112 8.875 1.03293 9.225 1.2964 9.4875L7.09257 14.65C7.35603 14.9125 7.61949 15 7.97078 15C8.32206 15 8.58552 14.9125 8.84899 14.65L14.733 9.4875C14.9964 9.225 15.0843 8.875 14.9086 8.525ZM11.4836 4.5H9.28809C9.02463 4.5 8.84899 4.325 8.84899 4.0625V1.875C10.1663 2.1375 11.2201 3.1875 11.4836 4.5ZM8.23424 14.0375C8.0586 14.2125 7.79514 14.2125 7.61949 14.0375L1.82332 8.875H4.01884C4.2823 8.875 4.45794 8.7 4.45794 8.4375V2.3125C4.45794 2.05 4.63359 1.875 4.89705 1.875H7.97078V4.0625C7.97078 4.7625 8.58552 5.375 9.28809 5.375H11.4836V8.4375C11.4836 8.7 11.6593 8.875 11.9227 8.875H14.1182L8.23424 14.0375Z"
      fill="currentColor"
    />
  </svg>
)

export default Download
